import BrazilFlagIcon from '@/assets/flags/brazil.svg?react';
import ArgentinaFlagIcon from '@/assets/flags/argentina.svg?react';
import ColombiaFlagIcon from '@/assets/flags/colombia.svg?react';
import CuracaoFlagIcon from '@/assets/flags/curacao.svg?react';
import USAFlagIcon from '@/assets/flags/united states.svg?react';
import ItalyFlagIcon from '@/assets/flags/italy.svg?react';
import NetherlandsFlagIcon from '@/assets/flags/netherlands.svg?react';
import CanadaFlagIcon from '@/assets/flags/canada.svg?react';
import PeruFlagIcon from '@/assets/flags/peru.svg?react';
import RomaniaFlagIcon from '@/assets/flags/romania.svg?react';
import SouthAfricaFlagIcon from '@/assets/flags/south africa.svg?react';
import SpainFlagIcon from '@/assets/flags/spain.svg?react';
import MaltaFlagIcon from '@/assets/flags/malta.svg?react';
import BulgariaFlagIcon from '@/assets/flags/bulgaria.svg?react';
import ChinaFlagIcon from '@/assets/flags/china.svg?react';
import CroatiaFlagIcon from '@/assets/flags/croatia.svg?react';
import DenmarkFlagIcon from '@/assets/flags/denmark.svg?react';
import EnglandFlagIcon from '@/assets/flags/england.svg?react';
import FinlandFlagIcon from '@/assets/flags/finland.svg?react';
import FranceFlagIcon from '@/assets/flags/france.svg?react';
import GermanyFlagIcon from '@/assets/flags/germany.svg?react';
import GreeceFlagIcon from '@/assets/flags/greece.svg?react';
import NorwayFlagIcon from '@/assets/flags/norway.svg?react';
import SwedenFlagIcon from '@/assets/flags/sweden.svg?react';
import RussiaFlagIcon from '@/assets/flags/russia.svg?react';
import TurkeyFlagIcon from '@/assets/flags/turkey.svg?react';
import PolandFlagIcon from '@/assets/flags/poland.svg?react';
import EstoniaFlagIcon from '@/assets/flags/estonia.svg?react';
import HungaryFlagIcon from '@/assets/flags/hungary.svg?react';
import SlovakiaFlagIcon from '@/assets/flags/slovakia.svg?react';
import VietnamFlagIcon from '@/assets/flags/vietnam.svg?react';
import JapanFlagIcon from '@/assets/flags/japan.svg?react';
import KoreaFlagIcon from '@/assets/flags/south korea.svg?react';
import ThailandFlagIcon from '@/assets/flags/thailand.svg?react';
import IndonesiaFlagIcon from '@/assets/flags/indonesia.svg?react';
import CzechFlagIcon from '@/assets/flags/czech republic.svg?react';
import PortugalFlagIcon from '@/assets/flags/portugal.svg?react';
import GeorgiaFlagIcon from '@/assets/flags/georgia.svg?react';
import AlbertaIcon from '@/assets/flags/alberta.svg?react';
import styled from '@emotion/styled';

const SvgIconWrapper = ({ src }: { src: string }) => (
  <Root>
    <img src={src} />
  </Root>
);

const Root = styled('div')({
  width: 16,
  height: 16,
  borderRadius: '50%',
  overflow: 'hidden',

  img: {
    width: '100%',
    height: '100%',
  },
});

export const Flags = {
  georgia: <GeorgiaFlagIcon />,
  argentina: <ArgentinaFlagIcon />,
  brazil: <BrazilFlagIcon />,
  colombia: <ColombiaFlagIcon />,
  curacao: <CuracaoFlagIcon />,
  usa: <USAFlagIcon />,
  italy: <ItalyFlagIcon />,
  netherlands: <NetherlandsFlagIcon />,
  canada: <CanadaFlagIcon />,
  peru: <PeruFlagIcon />,
  romania: <RomaniaFlagIcon />,
  southAfrica: <SouthAfricaFlagIcon />,
  spain: <SpainFlagIcon />,
  malta: <MaltaFlagIcon />,
  bulgaria: <BulgariaFlagIcon />,
  china: <ChinaFlagIcon />,
  croatia: <CroatiaFlagIcon />,
  denmark: <DenmarkFlagIcon />,
  england: <EnglandFlagIcon />,
  finland: <FinlandFlagIcon />,
  france: <FranceFlagIcon />,
  germany: <GermanyFlagIcon />,
  greece: <GreeceFlagIcon />,
  portugal: <PortugalFlagIcon />,
  norway: <NorwayFlagIcon />,
  sweden: <SwedenFlagIcon />,
  russia: <RussiaFlagIcon />,
  turkey: <TurkeyFlagIcon />,
  poland: <PolandFlagIcon />,
  estonia: <EstoniaFlagIcon />,
  hungary: <HungaryFlagIcon />,
  slovakia: <SlovakiaFlagIcon />,
  vietnam: <VietnamFlagIcon />,
  japan: <JapanFlagIcon />,
  korea: <KoreaFlagIcon />,
  thailand: <ThailandFlagIcon />,
  indonesia: <IndonesiaFlagIcon />,
  czech: <CzechFlagIcon />,
  switzerland: (
    <SvgIconWrapper src="https://flagcdn.com/w20/ch.png" />
  ),
  pennsylvania: (
    <SvgIconWrapper src="https://flagcdn.com/w20/us-pa.png" />
  ),
  westVirginia: (
    <SvgIconWrapper src="https://flagcdn.com/w20/us-wv.png" />
  ),
  alberta: <AlbertaIcon />,
};
